import React, { useCallback, useState } from 'react'
import { Link, withRouter } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import DeleteModal from '../../../components/delete-modal'
import Loading from '../../../components/loading'
import { deleteFaq } from '../../../actions/faq'

const TableFaqs = (props) => {
  const [itemDelete, setItemDelete] = useState({ number: '' })
  const [openModal, setOpenModal] = useState(false)
  const columns = [
    {
      name: '#',
      selector: 'number',
      sortable: true,
    },
    {
      name: 'Pergunta',
      selector: 'question',
      sortable: true,
      grow: 2
    },
    {
      name: 'Resposta',
      selector: 'answer',
      sortable: true,
      grow: 2
    },
    {
      name: 'Ações',
      cell: (item) => (
        <div>
          <Link to="#">
            <i className="material-icons text-danger rtd_button" onClick={() => confirmDelete(item)}>delete_forever</i>
          </Link>
        </div>
      ),
      button: true,
    },
  ]

  const handleRowClicked = useCallback(reg => {
    props.history.push(`/faqs-adm/${reg.id}`)
  }, [props])

  const confirmDelete = useCallback((item) => {
    setOpenModal(true)
    setItemDelete({ id: item.id, number: item.number })
  }, [])

  const deleteItem = useCallback(() => {
    deleteFaq(itemDelete.id).then(() => {
      props.loadFaqs()
      setOpenModal(false)
      setItemDelete({ number: '' })
    })
  }, [props, itemDelete])

  const cancelDelete = useCallback(() => {
    setOpenModal(false)
    setItemDelete({ name: '' })
  }, [])

  return (
    < div className="row" >
      <div className="col">
        <DataTable
          columns={columns}
          data={props.data}
          pointerOnHover
          highlightOnHover
          noDataComponent="Nenhum registro encontrado"
          onRowClicked={handleRowClicked}
          progressPending={props.loading}
          progressComponent={<Loading />}
        />
      </div>

      <DeleteModal
        isOpen={openModal}
        isHide={cancelDelete}
        itemDeleteName={`a pergunta nº ${itemDelete.number}`}
        onDeleteItem={deleteItem}
      />
    </div >
  )
}

TableFaqs.defaultProps = {
  data: Array,
  loadFaqs: Function,
  loading: Boolean,
  setLoading: Function
}

export default withRouter(TableFaqs)